import isEmpty from 'lodash/isEmpty';

import api from 'helpers/api';
import * as auth from 'helpers/auth';

export function authenticate() {
  const headers = auth.getAuthHeaders();

  if (isEmpty(headers)) {
    return Promise.reject();
  }

  return api.backend.get('auth/validate_token', { headers }).then(response => {
    auth.setAuthHeaders(response.headers);

    return response.data.data;
  });
}

export function logout() {
  auth.removeAuthHeaders();

  return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/api/auth.js